import { API_URL } from '../config/config';
import { postRequest } from '../utils/axiosUtils';

export const fileUpload = async (file, userId) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('by', userId);
  const res = await postRequest({
    url: `${API_URL}/file/admin/upload`,
    data: formData,
    headers: { tokenData: localStorage.getItem('authToken') || null },
  });

  if (res.status >= 200 && res.status < 300 && res.data) {
    return res.data?.data;
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};
